export const T = {
  en_GB: {
    compliance: "Compliance",
    title: "Clients review",
    description:
      "Screening standing per client. PEP and sanction are independent findings — a client can be both. Filter by view and screening to work through the ones that need follow-up.",
    view: "View",
    screening: "Screening",
    all: "All",
    name: "Name",
    searchPlaceholder: "Search by name",
    verifiedIdFilter: "Verified ID",
    verifiedIdAll: "All",
    verifiedIdVerified: "Verified",
    verifiedId1y: "Verified last 1Y",
    verifiedId3y: "Verified last 3Y",
    verifiedIdNot: "Not verified",
    lastUpdated: "Last updated",
    lastUpdatedAnytime: "Anytime",
    lastUpdatedToday: "Today",
    lastUpdatedWeek: "This week",
    lastUpdatedMonth: "This month",
    lastUpdatedQuarter: "This quarter",
    lastUpdatedYear: "This year",
    pep: "PEP",
    sanctioned: "Sanctioned",
    lastChecked: "Last checked",
    empty: "No clients match this filter.",
    filterClear: "No hits",
    filterPep: "PEP",
    filterSanctioned: "Sanctioned",
    filterFailed: "Check failed",
    filterNotChecked: "Never checked",
    filterNeedsReview: "Needs review",
    filterIncomplete: "PEP not assessed",
    filterAccepted: "Accepted",
    filterBlocked: "Blocked",
    statusColumn: "Status",
    actions: "Actions",
    review: "Review",
    needsReview: "Needs review",
    accepted: "Accepted",
    blocked: "Blocked",
    notAMatch: "Not a match",
    lastAttemptFailed: "(last check failed)",
    reviewFailed: "Could not save the review",
    yes: "Yes",
    no: "No",
    failedShort: "Failed",
    never: "Never",
    incomplete: "PEP not assessed",
    notAssessed: "Not assessed",
    subjectColumn: "PEP screened",
    subjectSelf: "Client",
    subjectNone: "No representative registered",
    subjectRepHint:
      "PEP is a property of a person — this is the representative screened on the client's behalf.",
  },
  nb_NO: {
    compliance: "Compliance",
    title: "Kundegjennomgang",
    description:
      "Screeningstatus per kunde. PEP og sanksjon er uavhengige funn — en kunde kan være begge. Filtrer på visning og screening for å jobbe gjennom kundene som krever oppfølging.",
    view: "Visning",
    screening: "Screening",
    all: "Alle",
    name: "Navn",
    pep: "PEP",
    sanctioned: "Sanksjonert",
    lastChecked: "Sist sjekket",
    empty: "Ingen kunder passer dette filteret.",
    searchPlaceholder: "Søk på navn",
    verifiedIdFilter: "Verifisert ID",
    verifiedIdAll: "Alle",
    verifiedIdVerified: "Verifisert",
    verifiedId1y: "Verifisert siste 1 år",
    verifiedId3y: "Verifisert siste 3 år",
    verifiedIdNot: "Ikke verifisert",
    lastUpdated: "Sist oppdatert",
    lastUpdatedAnytime: "Når som helst",
    lastUpdatedToday: "I dag",
    lastUpdatedWeek: "Denne uken",
    lastUpdatedMonth: "Denne måneden",
    lastUpdatedQuarter: "Dette kvartalet",
    lastUpdatedYear: "I år",
    filterIncomplete: "PEP ikke vurdert",
    filterClear: "Ingen treff",
    filterPep: "PEP",
    filterSanctioned: "Sanksjonert",
    filterFailed: "Sjekk mislyktes",
    filterNotChecked: "Aldri sjekket",
    filterNeedsReview: "Trenger gjennomgang",
    filterAccepted: "Godkjent",
    filterBlocked: "Blokkert",
    statusColumn: "Status",
    actions: "Handlinger",
    review: "Vurder",
    needsReview: "Trenger gjennomgang",
    accepted: "Godkjent",
    blocked: "Blokkert",
    notAMatch: "Ikke treff",
    lastAttemptFailed: "(siste sjekk mislyktes)",
    reviewFailed: "Kunne ikke lagre vurderingen",
    yes: "Ja",
    no: "Nei",
    failedShort: "Mislyktes",
    never: "Aldri",
    incomplete: "PEP ikke vurdert",
    notAssessed: "Ikke vurdert",
    subjectColumn: "PEP-sjekket",
    subjectSelf: "Kunden",
    subjectNone: "Ingen representant registrert",
    subjectRepHint:
      "PEP gjelder en fysisk person — dette er representanten som er sjekket på vegne av kunden.",
  },
} as const;
